module.exports = __webpack_public_path__ + "static/media/002_Piso_Inferior_fade.2a08f85d.mp4";